import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseAutoCompleteWithMultipleSelectedItems from '@/components/AutoCompletes/BaseAutoCompleteWithMultipleSelectedItems.vue';
import deviceType from '@/types/DeviceType';
import { visibleDeviceTypes } from '@/services/consts';
import { ref, computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MultipleDeviceTypeAutoComplete',
  props: {
    modelValue: {},
    errorMessages: {}
  },
  emits: ['update:modelValue', 'blur'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const items = ref<deviceType[]>(visibleDeviceTypes);

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const emitBlur = () => {
  emit('blur');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseAutoCompleteWithMultipleSelectedItems, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    onBlur: emitBlur,
    label: "対応型番",
    itemName: "type",
    items: items.value,
    "error-messages": __props.errorMessages
  }, null, 8, ["modelValue", "items", "error-messages"]))
}
}

})